import { Component, Input } from '@angular/core';
import { ProjectPin } from '@shared/interfaces/pins.interface';

@Component({
    selector: 'app-map-infowindow-project',
    templateUrl: './map-infowindow-project.component.html'
})
export class MapInfoWindowProjectComponent {
    @Input() pin: ProjectPin;
}
